document.addEventListener( 'DOMContentLoaded', () => {
    flickityVerticalVideoMob ()
} )
window.addEventListener( 'resize', () => {
    flickityVerticalVideoMob ()
} )

function flickityVerticalVideoMob () {
    const blocks = document.querySelectorAll( '.starter-bundle-block' )
    if ( !blocks.length ) return

    if ( window.matchMedia( '(min-width: 1024px)' ).matches ) return

    blocks.forEach( ( block ) => {
        const items = block.querySelectorAll( '.starter-bundle-block .product-container' )
        if ( !items.length ) return

        const holder = block.querySelector( '.starter-bundle-block .starter-bundle-block__products' )
        const flickity = new Flickity( holder, {
            prevNextButtons: false,
            cellAlign: 'left',
            groupCells: false,
            imagesLoaded: true,
            pageDots: false,
            percentPosition: true,
            autoPlay: false,
            pauseAutoPlayOnHover: false,
            //adaptiveHeight: false,
            cellSelector: '.starter-bundle-block .product-container',
            selectedAttraction: 0.05,
            wrapAround: false,
            friction: 0.5,
            adaptiveHeight: true,
            contain: true,
            // on: {
            //     ready () {
            //         for ( let item of items ) {
            //             item.style.height = '100%'
            //         }
            //     }
            // } 
        } )
    } )
}